import ConciergePanel from 'app/concierge/panel';
import { useDispatch } from 'react-redux';
import { hide, show, toggleVisibility } from 'store/conciergeSlice';
import { useEffect } from 'react';
import { SxProps, Theme } from '@mui/material';

interface IProps {
    welcome_icon?: string;
    welcome_icon_width?: number;
    welcome_icon_height?: number;
    bot_icon?: string;
    title?: string;
    description?: string;
    start_new_chat_after?: number;
    show_source_selector?: boolean;
    display_model_name?: boolean;
    suggested_prompts?: string[];
    show_search_request?: boolean;
    include_content_search?: boolean;
    include_help_docs?: boolean;
    include_glossary_terms?: boolean;
    include_custom_faq?: boolean;
    available_domains?: string[];
    selected_domains?: string[];
    load_more?: boolean;
    extra_url_params?: { [key: string]: string | number | (string | number)[] };
    use_info_button?: boolean;
    custom_styles?: {
        panel?: SxProps<Theme>;
        welcomePage?: SxProps<Theme>;
        header?: SxProps<Theme>;
        footer?: SxProps<Theme>;
        activeChat?: SxProps<Theme>;
        activeChatMessage?: SxProps<Theme>;
        activeChatMessageResultItem?: SxProps<Theme>;
    };
}

interface ConciergePanelEvent {
    action: string;
    payload?: any;
}

function normalizeExtraUrlParams(params?: {
    [key: string]: string | number | (string | number)[];
}): { [key: string]: string } | undefined {
    if (!params) return undefined;

    const result: { [key: string]: string } = {};
    for (const [key, value] of Object.entries(params)) {
        result[key] = Array.isArray(value) ? JSON.stringify(value) : String(value);
    }

    return result;
}

export default function ConciergeWrapper({ props }: { props: IProps }) {
    const dispatch = useDispatch();

    useEffect(() => {
        const handler = (e: Event) => {
            if (e instanceof CustomEvent && e.detail) {
                const params = e.detail as ConciergePanelEvent;

                if (params.action === 'toggle-panel') {
                    dispatch(toggleVisibility());
                }
                if (params.action === 'show-panel') {
                    dispatch(show());
                }
                if (params.action === 'hide-panel') {
                    dispatch(hide());
                }
            }
        };
        document.addEventListener('mi-concierge-panel', handler as EventListener);

        return () => document.removeEventListener('mi-concierge-panel', handler as EventListener);
    }, [dispatch]);

    return (
        <ConciergePanel
            isAppPanel
            title={props.title}
            description={props.description}
            suggestedPrompts={props.suggested_prompts}
            botIcon={props.bot_icon}
            displayModelName={props.display_model_name}
            showSourceSelector={props.show_source_selector}
            startNewChatAfter={props.start_new_chat_after}
            welcomeIcon={props.welcome_icon}
            welcomeIconHeight={props.welcome_icon_height}
            welcomeIconWidth={props.welcome_icon_width}
            availableDomains={props.available_domains}
            selectedDomains={props.selected_domains}
            includeContentSearch={props.include_content_search}
            includeCustomFaq={props.include_custom_faq}
            includeGlossaryTerms={props.include_glossary_terms}
            includeHelpDocs={props.include_help_docs}
            showSearchRequest={props.show_search_request}
            loadMore={props.load_more}
            customStyles={props.custom_styles}
            extraUrlParams={normalizeExtraUrlParams(props.extra_url_params)}
            useInfoButton={props.use_info_button}
        />
    );
}
